import React from 'react'

function BlogContent() {
  return (
    <section className='section-h-full dorac-grid-bg flex items-center justify-center text-center'>
      <div className='container mx-auto px-4'>
        <span className='section-eyebrow'>Blog Dorac</span>
        <h1 className='section-title mb-4'>Em construção</h1>
        <p className='section-subtitle mx-auto'>Novos conteúdos chegando em breve.</p>
      </div>
    </section>
  )
}

export default BlogContent
